import { render, staticRenderFns } from "./TextAndToolsPanel.vue?vue&type=template&id=0674c8af&scoped=true&"
import script from "./TextAndToolsPanel.vue?vue&type=script&lang=js&"
export * from "./TextAndToolsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TextAndToolsPanel.vue?vue&type=style&index=0&id=0674c8af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../morphology/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0674c8af",
  null
  
)

export default component.exports